import { render, staticRenderFns } from "./ResellerProductViewGallery.vue?vue&type=template&id=4017b5aa&"
import script from "./ResellerProductViewGallery.vue?vue&type=script&lang=js&"
export * from "./ResellerProductViewGallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports